import 'babel-polyfill';
import Vue from 'vue';
import VueRouter from 'vue-router';
// import store from './vuex/store';
import App from './App';
import TopPage from './components/TopPage';

Vue.use(VueRouter);

const routes = [
  { path: '', component: TopPage },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

new Vue({
  render(h) {
    return h(App);
  },
  router,
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js